import { render, staticRenderFns } from "./choiceCity.vue?vue&type=template&id=a64850d6&scoped=true"
import script from "./choiceCity.vue?vue&type=script&lang=js"
export * from "./choiceCity.vue?vue&type=script&lang=js"
import style0 from "./choiceCity.vue?vue&type=style&index=0&id=a64850d6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a64850d6",
  null
  
)

export default component.exports